var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16pt",
    height: "16pt",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.54902%,29.019608%,52.941176%)",
      fillOpacity: 1
    },
    d: "M 1.773438 0 L 14.226562 0 C 15.207031 0 16 0.792969 16 1.773438 L 16 14.226562 C 16 15.207031 15.207031 16 14.226562 16 L 1.773438 16 C 0.792969 16 0 15.207031 0 14.226562 L 0 1.773438 C 0 0.792969 0.792969 0 1.773438 0 Z M 1.773438 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.941406 1.4375 L 8.554688 1.4375 C 10.226562 1.4375 11.507812 1.8125 12.398438 2.554688 C 13.292969 3.292969 13.742188 4.347656 13.742188 5.71875 C 13.742188 7.097656 13.292969 8.15625 12.398438 8.902344 C 11.507812 9.640625 10.226562 10.007812 8.554688 10.007812 L 6.324219 10.007812 L 6.324219 14.5625 L 2.941406 14.5625 L 2.941406 1.4375 M 6.324219 3.890625 L 6.324219 7.554688 L 8.195312 7.554688 C 8.851562 7.554688 9.359375 7.398438 9.714844 7.082031 C 10.074219 6.757812 10.253906 6.304688 10.253906 5.71875 C 10.253906 5.132812 10.074219 4.683594 9.714844 4.367188 C 9.359375 4.050781 8.851562 3.890625 8.195312 3.890625 L 6.324219 3.890625 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.ae5fcfa5487f29f1893ae8a721fc3886.svg";
export { ForwardRef as ReactComponent };